import styled, { css } from 'styled-components';
import { Image as BoltImage } from '@sainsburys-tech/bolt';
var LegFinishPickerContainer = styled.div.withConfig({
  displayName: "LegFinishPickerstyles__LegFinishPickerContainer",
  componentId: "sc-1c98ngc-0"
})(["display:flex;flex-wrap:wrap;gap:15px;"]);
var TileContainer = styled.div.withConfig({
  displayName: "LegFinishPickerstyles__TileContainer",
  componentId: "sc-1c98ngc-1"
})(["margin-top:15px;border-bottom:1px solid ", ";flex:0 1 calc(50% - 8px);"], function (props) {
  return props.theme.color.monochrome.light;
});
var TileItem = styled.button.withConfig({
  displayName: "LegFinishPickerstyles__TileItem",
  componentId: "sc-1c98ngc-2"
})(["position:relative;border:none;font:inherit;background:none;padding:0;"]);
var Image = styled(BoltImage).withConfig({
  displayName: "LegFinishPickerstyles__Image",
  componentId: "sc-1c98ngc-3"
})(["display:block;border-radius:4px;width:100%;max-width:", "px;", ""], function (props) {
  return props.width;
}, function (props) {
  return props.$isSelected && css(["border:2px solid ", ";padding:8px;border-radius:4px;"], props.theme.color.palette['blue-60']);
});
var TileText = styled.span.withConfig({
  displayName: "LegFinishPickerstyles__TileText",
  componentId: "sc-1c98ngc-4"
})(["display:block;text-align:left;padding:15px 0;font-size:", ";font-weight:", ";"], function (props) {
  return props.theme.font.size['label-1'];
}, function (props) {
  return props.theme.font.weight['label-1'];
});
export { LegFinishPickerContainer, TileContainer, TileItem, Image, TileText };